// src/Components/TopBar/PendingActionsButton.tsx
import { useClientPendingActions } from 'app/hooks/useClientPendingActions';
import Button from 'Components/Buttons/Button';
import { useAuth } from 'utils/AuthProvider';
import { useNavigate } from 'react-router-dom';

import './PendingActionsButton.css';

/**
 * Green pill (“Pay Now”, “Sign letter”, …) shown only to clients
 * when at least one pending action exists.
 *
 * ‑‑ Enhancement ‑‑
 *   • If the first pending action is **Orders**, show “$” instead of the exact
 *     number, because the backend may aggregate multiple models.
 */
export default function PendingActionsButton() {
  const { isClient } = useAuth();
  const { total, first, loading } = useClientPendingActions(isClient);
  const navigate = useNavigate();

  if (!isClient || total === 0) return null;

  /* ---------- what goes inside the red badge ------------------------ */
  const badgeText =
    first?.key === 'orders' ? '$$$' : String(first?.count ?? total);

  return (
    <Button
      theme="green-fill"
      className="pending-button"
      isLoading={loading}
      onClick={() => first && navigate(first.href)}
      aria-label={`You have pending ${first?.label ?? 'actions'}`}
    >
      {!loading && (
        <>
          <span className="capitalize">{first?.label}</span>
          <span className="badge">{badgeText}</span>
        </>
      )}
    </Button>
  );
}
